import * as preact from 'preact'
const { h, Component } = preact
import * as style from './style.css'
import { PullQuote } from '@nrk/dh-feature-components'
import '../../../../../node_modules/@nrk/dh-feature-components/dist/commonjs/PullQuote/index.css'
import PureComponent from '../../../lib/preact-pure-component'

interface Props {
  text?: string
  id: string
  style?: string
  cite?: string
  active: boolean
  preload: boolean
}

export class Blockquote extends PureComponent<Props, {}> {
  render() {
    return (
      <div className={style.quote}>
        <PullQuote html={this.props.text} cite={this.props.cite} />
      </div>
    )
  }
}
